import React from "react";

const sections = [
  ["1. Acceptance of terms", "By accessing NearbyDeals you agree to these terms. If you do not agree, please do not use the service."],
  ["2. Using the platform", "NearbyDeals connects customers with independent local shops. You agree to use the platform lawfully and not to misuse coupons, reviews or messaging features."],
  ["3. Accounts", "You are responsible for keeping your login credentials secure. Shop owners are responsible for the accuracy of their listings and offers."],
  ["4. Coupons & offers", "Coupons are issued by individual shops and subject to their terms. NearbyDeals is not liable for offers honoured or withdrawn by shops."],
  ["5. Content & reviews", "Reviews must be genuine and respectful. We may remove content that is abusive, fraudulent or violates our guidelines."],
  ["6. Limitation of liability", "The platform is provided 'as is'. NearbyDeals is not liable for transactions, disputes or damages arising between customers and shops."],
  ["7. Changes", "We may update these terms. Continued use after changes constitutes acceptance of the revised terms."],
];

export default function Terms() {
  return <LegalPage title="Terms of Service" sections={sections} />;
}

export function LegalPage({ title, sections }) {
  return (
    <div className="pt-[72px] min-h-screen">
      <section className="mx-auto max-w-3xl px-5 sm:px-8 py-24">
        <p className="font-display uppercase tracking-[0.25em] text-primary text-sm font-bold mb-6">Legal</p>
        <h1 className="font-display font-extrabold text-5xl sm:text-6xl tracking-tighter mb-4">{title}</h1>
        <p className="text-muted-foreground mb-12">Last updated {new Date().toLocaleDateString()}</p>
        <div className="space-y-10">
          {sections.map(([h, b], i) => (
            <div key={i}>
              <h2 className="font-display font-bold text-xl mb-3">{h}</h2>
              <p className="text-muted-foreground leading-relaxed">{b}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
